
import { supabase } from '@/integrations/supabase/client';
import { Courier } from '@/services/types';
import { checkSupabaseConnection } from '@/utils/supabase/courierQueries';

export interface CourierDataResult {
  couriers: Courier[];
  totalCount: number;
  connectionError: string | null;
}

/**
 * Получает все данные о курьерах без пагинации
 */
export const fetchAllCouriers = async (): Promise<CourierDataResult> => {
  try {
    console.log('Получение всех данных курьеров...');
    
    // Проверяем подключение к Supabase
    const connectionResult = await checkSupabaseConnection();
    if (!connectionResult.connected) {
      throw new Error(`Ошибка подключения к Supabase: ${connectionResult.error?.message || 'Неизвестная ошибка'}`);
    }

    // Получаем все данные курьеров
    const response = await supabase
      .from('couriers')
      .select('*, payments:payments(id, amount, payment_date)')
      .order('name', { ascending: true });

    if (response.error) {
      console.error('Ошибка запроса Supabase:', response.error);
      throw response.error;
    }

    // Приводим к типу Courier, добавляя необходимые поля
    const mappedCouriers: Courier[] = (response.data || []).map(courier => ({
      ...courier,
      status: (courier.status || 'inactive') as 'active' | 'inactive',
      totalRentals: courier.totalrentals || 0,
      registeredAt: courier.created_at || new Date().toISOString(),
      paymentCount: courier.payments?.length || 0
    }));
    
    console.log(`Обработано ${mappedCouriers.length} курьеров`);
    return {
      couriers: mappedCouriers,
      totalCount: mappedCouriers.length,
      connectionError: null
    };

  } catch (error: any) {
    console.error('Ошибка при получении данных о курьерах:', error);
    
    return {
      couriers: [],
      totalCount: 0,
      connectionError: error.message
    };
  }
};

// Оставляем для обратной совместимости, теперь просто вызывает fetchAllCouriers
export const fetchCouriersWithPagination = fetchAllCouriers;
export const fetchCouriersStats = fetchAllCouriers;
